import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";
import { useTranslation } from "../../hooks";
const TONE_COLOR = {
    success: (theme) => theme.palette.success.main,
    warning: (theme) => theme.palette.warning.main,
    error: (theme) => theme.palette.error.main,
    neutral: (theme) => theme.palette.text.secondary,
};
export function pillColor(tone, theme) {
    return TONE_COLOR[tone](theme);
}
export function PortalStatusPill({ pill }) {
    const { t } = useTranslation("portal");
    return (_jsxs(Box, { component: "span", sx: (theme) => {
            const color = TONE_COLOR[pill.tone](theme);
            return {
                display: "inline-flex",
                alignItems: "center",
                gap: 0.625,
                px: 1,
                py: 0.375,
                borderRadius: 999,
                fontSize: 11,
                fontWeight: 600,
                letterSpacing: "0.01em",
                lineHeight: 1.5,
                whiteSpace: "nowrap",
                color,
                backgroundColor: alpha(color, 0.1),
                border: `1px solid ${alpha(color, 0.2)}`,
            };
        }, children: [_jsx(Box, { component: "span", "aria-hidden": "true", sx: {
                    width: 5,
                    height: 5,
                    borderRadius: "50%",
                    backgroundColor: "currentColor",
                    flexShrink: 0,
                } }), t(pill.labelKey)] }));
}
